import React from 'react';
import ReactDOM from 'react-dom';
import './MainBody.css'

class WhoAmI extends React.Component {
  render (){
    return (
      <div class="container-fluid bg-2 text-center">
        <h3>Who Am I?</h3>
        <p>Born in 1998. A motivated programmer with problem-solving and critical thinking skills,
         as well as meticulous attention to detail and methodical nature. Reliable and hard worker.
          Forward-thinking and resourceful with a diligent mindset and a disciplined approach.</p>
        <p>I have a big concern toward parallel and distributed systems (Digital Infrastructure),
        I'm looking to improve my concepts more deeply in this domain to have better knowledge,
         I'm excited to do a Ph.D in this domain to involve in improving the characteristic of the operating systems after my graduation
         from the M2 Master degree in Digital Infrastructure Domain.</p>
      </div>
    )
  }
}

export default WhoAmI;
